import React from 'react';
import { Asterisk } from 'lucide-react';
export function Marquee() {
  const count = 6;
  const logos = Array.from({
    length: count
  });
  const Logo = ({
    index
  }: {
    index: number;
  }) => <div className="flex items-center shrink-0" data-id="element-105" data-mp="2ij4dhoagwfu9">
      <img src="https://cdn.magicpatterns.com/uploads/7inTevuhRF6mEgasSL53Js/Untitled_(1880_x_940_px).png" alt="En2Action" className="h-16 sm:h-20 w-auto object-contain mx-8" key={index} data-id="element-106" data-mp="2ijxc21z9vz1b" />
      <Asterisk className="text-foodGold shrink-0" size={32} data-id="element-107" data-mp="3b5ysw6sfgp0v" />
    </div>;
  return <div className="bg-foodMaroon py-6 overflow-hidden border-y-4 border-foodMaroon" data-id="element-108" data-mp="3675emc5bgtzn">
      <div className="flex w-max animate-marquee items-center" data-id="element-109" data-mp="318c3gqdi5f2n">
        {/* First set */}
        {logos.map((_, index) => <Logo key={`a-${index}`} index={index} data-id="element-110" data-mp="1pv07f1nzi0r1" data-mpi={index} />)}
        {/* Duplicate set for seamless loop */}
        {logos.map((_, index) => <Logo key={`b-${index}`} index={index} data-id="element-111" data-mp="1lslmmc0r8qx4" data-mpi={index} />)}
      </div>
    </div>;
}